<template lang="pug">
#user_credit_card_modal_wrapper
  b-modal#set-user-credit-card(title='クレジットカードを登録してください。',size="lg",'hide-footer')
    alert-error(v-if="error",:msg="error_msg")
    card-form(:stripe_key="stripe_key", @submit_form="subscribeToPlan")
  b-modal#set-user-credit-card-success(title='カード登録完了','hide-footer')
    p カード情報が送信されました。決済完了までお待ちください
</template>

<script>

import Vue from 'vue'

import CardForm from '../card_form.vue'

import AlertError from '../../components/parts/error.vue'

export default {
  data(){
    return {
      form_url: this.user_host,
      error: false,
      error_msg: ""
    }
  },
  props: {
    stripe_key: String,
    redirect_path: {
      type: String,
      default: null
    }
  },
  methods: {
    async subscribeToPlan(token){
      this.error = false
      this.$store.commit("user/setPlanId", this.$store.state.user.plan_to_change.id)
      try{
        await this.$store.dispatch("user/createSubscription", token)
        // クーポンコードリセット
        this.$store.commit("user/setCouponCode", '')
        if(this.redirect_path!=null){
          location.href=this.redirect_path
        } else {
          this.$bvModal.hide('set-user-credit-card')
          this.$bvModal.show('set-user-credit-card-success')
          this.$store.commit("user/setInvoicePending", true)
        }
      } catch(e) {
        //console.log(e)
        //console.log(e.response)
        this.error = true
        this.error_msg = e.response.data.error
        this.$store.commit("user/offSubmittingCard")
      }

    },
  },
  components: {
    CardForm,
    AlertError
  },
  async mounted(){
    await Vue.nextTick()
  },
}
</script>
<style lang="scss" scoped>
</style>
